fragment AiStatFragment on AiFeatureStat {
    displayName
    tooltip
    ... on AiValueStat {
        value
    }
    ... on AiPercentageStat {
        percentage
    }
    ... on AiUserStat {
        user {
            id
            name
            initials
            avatarUrl
        }
    }
    ... on AiLimitStat {
        limitValue: value
        limit
        isUnlimited
    }
}
